













import { loginCheck } from '@/modules/util/SapUtil'
import UidSetCookie from '@/modules/util/UidSetCookie'
import { Vue, Component } from 'vue-property-decorator'
import { membershipState } from '../../store/modules/MembershipState'

@Component
export default class MypageICon extends Vue {
  // -------------------------------------------------------------------------------------------------------------------
  // Props
  get isLogin(): boolean {
    return membershipState.isLogin
  }

  // -------------------------------------------------------------------------------------------------------------------
  // data
  private mypagetop = ''
  private uidCookie = new UidSetCookie()

  // -------------------------------------------------------------------------------------------------------------------
  // hock
  private beforeMount() {
    // pageで設定したkeyを取得
    this.mypagetop = drupalSettings.vueComponent.membershipcontroll.myPage.top
  }

  private mounted() {
    // 野良リンクにイベント追加
    this.setEventForHTMLElements()
  }

  // -------------------------------------------------------------------------------------------------------------------
  // mothod
  private movetomypagetop() {
    this.executionLoginCheck(this.mypagetop)
  }

  /**
   * Drupalで出力されているaタグ要素にクリックイベントを追加し、
   * クリックされたときに認証領域のCookieを発行する
   */
  private setEventForHTMLElements() {
    const nodeList = document.querySelectorAll('.js-authLink')
    if (nodeList.length > 0) {
      // 各リンクにイベント追加
      nodeList.forEach((node) => {
        const href = node.getAttribute('href') ?? ''
        node.addEventListener('click', (event) => {
          event.preventDefault()

          this.executionLoginCheck(href)
        })
      })
    }
  }

  /**
   * ログインチェック
   */
  private executionLoginCheck(url: string) {
    const move = () => {
      window.location.href = url
    }

    // ログイン状況にかかわらず、遷移する
    // ただし、未ログインの場合はアクセスページを経由する
    loginCheck(move, move)
  }
}
